import type { WebPage, WebPageComponent } from '@/types/page';
import TextComponent from './TextComponent';
import ImageComponent from './ImageComponent';
import HtmlComponent from './HtmlComponent';
import ImageArrayComponent from './ImageArrayComponent';

interface PageRendererProps {
  page: WebPage;
}

export default function PageRenderer({ page }: PageRendererProps) {
  if (!page || !page.components || page.components.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-500">
        页面内容为空
      </div>
    );
  }

  // 渲染单个组件
  const renderComponent = (component: WebPageComponent, index: number) => {
    switch (component.type) {
      case 'TEXT':
        return component.textConfig ? (
          <TextComponent key={index} config={component.textConfig} />
        ) : null;

      case 'IMAGE':
        return component.imageConfig ? (
          <ImageComponent key={index} config={component.imageConfig} />
        ) : null;

      case 'HTML':
        return component.htmlConfig ? (
          <HtmlComponent key={index} config={component.htmlConfig} />
        ) : null;

      case 'IMAGE_ARRAY':
        return component.imageArrayConfig ? (
          <ImageArrayComponent key={index} config={component.imageArrayConfig} />
        ) : null;

      default:
        console.warn('未知组件类型:', component.type);
        return null;
    }
  };

  return (
    <div className="page-renderer">
      {page.components.map((component, index) => renderComponent(component, index))}
    </div>
  );
}
